module.exports = __webpack_public_path__ + "img/baoxiaomi-opk-advertise.191b8725.png";